import React, { useState } from "react";
import Container from "@mui/material/Container";
import { Box, Typography } from "@mui/material";
import Slider from "react-slick";
// import screen1 from "../images/screen-1.png";
// import screen1 from "../images/Splash.png";
import screen1 from "../images/pageImg1.svg";
import screen2 from "../images/pageImg2.svg";
import screen3 from "../images/pageImg3.svg";
import screen4 from "../images/pageImg4.svg";
import screen5 from "../images/pageImg5.svg";
import screen6 from "../images/pageImg6.svg";
import screen7 from "../images/pageImg7.svg";
import screen8 from "../images/pageImg8.svg";
import styles from "../css/mobilePagesStyles.js"; 
// import "../css/PauseOnHover.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function PauseOnHover() {
  const [activeIndex, setActiveIndex] = useState(0); // Track active dot
  const classes = styles;

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: i === activeIndex ? "#0D8B5A" : "lightgray", // Active dot color
          cursor: "pointer",
        }}
      />
    ),
    afterChange: (current) => setActiveIndex(current), // Update active dot on change
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          dots: true
        }
      }
    ]
  };

  return (
    <Container>
      <Box id="Pages" sx={classes.container}>
        <Typography variant="h2" sx={classes.heading}>
            Mobile App Pages
        </Typography>
        <Typography variant="body1" sx={classes.subHeading}>
            Experience the power of AMBD - Australian Muslim Business Directory. Download now and support Muslim-owned businesses and services in Australia!
        </Typography>
        <Box sx={classes.divider}></Box>
      </Box>

      <Box sx={{ padding: "0px", mt: 2, width: '100%' }}>
        <Box className="slider-container-mobile">
          <Slider {...settings}>
            <div>
              <img src={screen1} className="slider-image" alt="screen" />
            </div>
            <div>
              <img src={screen2} className="slider-image" alt="screen1" />
            </div>
            <div>
              <img src={screen3} className="slider-image" alt="screen3" />
            </div>
            <div>
              <img src={screen4} className="slider-image" alt="screen" />
            </div>
            <div>
              <img src={screen5} className="slider-image" alt="screen1" />
            </div>
            <div>
              <img src={screen6} className="slider-image" alt="screen3" />
            </div>
            <div>
              <img src={screen7} className="slider-image" alt="screen3" />
            </div>
            <div>
              <img src={screen8} className="slider-image" alt="screen3" />
            </div>
          </Slider>
        </Box>
      </Box>
    </Container>
  );
}

export default PauseOnHover;
